module.exports = __webpack_public_path__ + "static/LoveDate-65b3460a45722779b1ebf7019de43a96.mp4";